<template>
  <!-- <hello-world /> -->
  <div class="px-7">
    <!-- <logo></logo> -->

    <bdc :url_data="url_data"></bdc>
  </div>
</template>

<script>
// import Logo from "../components/Logo.vue";
import Bdc from "../pages/Bdc.vue";
export default {
  name: "Home",
  mounted() {
    this.url_data = this.$route.params.id;
  },
  components: {
    // Logo,
    Bdc,
  },
  data: () => ({
    url_data: undefined,
    valid: true,
    name: " samir ",
    nameRules: { nom: "yahia", prenom: "marzouk" },
  }),
};
</script>
